/**
* DevExpress Dashboard (_data-source-factory-base.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { EFDataSource } from './ef-data-source';
import { ExcelDataSource } from './excel-data-source';
import { ExtractDataSource } from './extract-data-source';
import { JsonDataSource } from './json-data-source';
import { MongoDBDataSource } from './mongodb-data-source';
import { ObjectDataSource } from './object-data-source';
import { OlapDataSource } from './olap-data-source';
import { SqlDataSource } from './sql-data-source';
import { XpoDataSource } from './xpo-data-source';
export let _baseDataSourceTypesMap = {
    'ObjectDataSource': ObjectDataSource,
    'SqlDataSource': SqlDataSource,
    'OLAPDataSource': OlapDataSource,
    'EFDataSource': EFDataSource,
    'ExcelDataSource': ExcelDataSource,
    'ExtractFileDataSource': ExtractDataSource,
    'JsonDataSource': JsonDataSource,
    'XPObjectSource': XpoDataSource,
    'MongoDBDataSource': MongoDBDataSource
};
